import type { ReactElement } from 'react';
import SkeletonLine from '../../shared/skeletons/SkeletonLine';

// This is for when there is no addresses available/loading screen.
type Props = { isPrimary: boolean; };

function AddAddressSkeleton({ isPrimary = false }: Props): ReactElement {
  return (
    <div className="c-my-account__address__card ">
      <div>
        {isPrimary && (
        <h2 className="c-my-account__address__card__heading">
          Primary Address
        </h2>
        )}

        <SkeletonLine width={145} height={16} />
        <br />
        <SkeletonLine width={160} height={16} />
        <br />
        <SkeletonLine width={180} height={16} />
        <br />
        <SkeletonLine width={120} height={16} />
      </div>

      <div className="c-profile__address-card-actions">
        <SkeletonLine width={60} height={17} />
      </div>
    </div>
  );
}

export default AddAddressSkeleton;
